export default __webpack_public_path__ + "static/media/mexlog-image-fallback.20b45ee4.jpg";